import React from "react";

import { TicketDetail, SupportInfoAside } from "@/features/support";

/**
 * Ticket detay/konuşma sayfası (/support/tickets/:id).
 *
 * Tüm ekran boyutlarında viewport yüksekliğine sabitlenir; yalnızca mesaj
 * thread'i kayar, başlık ve cevap alanı sabit kalır (sohbet uygulaması
 * davranışı). Mobilde ekstra kaydırma mesafesi yaratmaması için yardım
 * bilgisi (e-posta/yanıt süresi) barındıran yan panel gizlenir — bu bilgi
 * zaten destek ana sayfasında mevcut.
 */
const SupportTicketDetailPage: React.FC = () => {
  return (
    <div className="mx-auto flex h-full w-full max-w-6xl flex-col gap-4 px-3 py-4 sm:gap-8 sm:px-4 sm:py-8 lg:py-10">
      <div className="grid min-h-0 flex-1 grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="flex min-h-0 flex-col lg:col-span-2">
          <TicketDetail />
        </div>
        <div className="hidden lg:block">
          <SupportInfoAside />
        </div>
      </div>
    </div>
  );
};

export default SupportTicketDetailPage;
